<div class="component-main">
    <div class="content">
        <h1 id="component-title">
            {{ pageTitle | myLbTranslate | titlecase }}
        </h1>
    </div>
    <form [formGroup]="userForm">
        <ng-container *ngIf="!editId && moduleIsPortal ? activeStep <= 5 : activeStep <=4">
            <div
                #step
                class="step"
                [class.active]="activeStep === 1"
                [class.complete]="activeStep > 1"
                formGroupName="step1">
                <h3>{{ 'rbac_users_details' | myLbTranslate }}</h3>
                <div class="step-content">
                    <ng-container *ngIf="activeStep === 1">
                        <div class="form-group" [hidden]="moduleIsPortal">
                            <label for="user-first-name">{{ 'name_first' | myLbTranslate }}*</label>
                            <div class="form-content">
                                <input
                                    id="user-first-name"
                                    formControlName="firstName"
                                    name="firstName"
                                    type="text">
                                <app-validation-messages [control]="userForm.get('step1.firstName')">
                                </app-validation-messages>
                            </div>
                        </div>
                        <div class="form-group" [hidden]="moduleIsPortal">
                            <label for="user-last-name">{{ 'name_last' | myLbTranslate }}*</label>
                            <div class="form-content">
                                <input
                                    id="user-last-name"
                                    formControlName="lastName"
                                    name="lastName"
                                    type="text">
                                <app-validation-messages [control]="userForm.get('step1.lastName')">
                                </app-validation-messages>
                            </div>
                        </div>
                        <div class="form-group" [hidden]="editId && moduleIsPortal">
                            <label for="user-email">{{ 'email' | myLbTranslate }}*</label>
                            <div class="form-content">
                                <input
                                    id="user-email"
                                    formControlName="email"
                                    name="email"
                                    type="text">
                                <app-validation-messages [control]="userForm.get('step1.email')">
                                </app-validation-messages>
                                <app-help class="help-button" tag="rbac-users_email"></app-help>
                            </div>
                        </div>
                        <div class="form-group" [hidden]="editId || !moduleIsPortal">
                            <label for="user-confirm-email">{{ 'confirm_email' | myLbTranslate }}*</label>
                            <div class="form-content">
                                <input
                                    id="user-confirm-email"
                                    formControlName="confirmEmail"
                                    name="confirmEmail"
                                    type="text">
                                <app-validation-messages [control]="userForm.get('step1.confirmEmail')">
                                </app-validation-messages>
                                <app-help class="help-button" tag="rbac-users_confirm-email"></app-help>
                            </div>
                        </div>
                        <div class="form-group" [hidden]="moduleIsPortal">
                            <label for="user-password">{{ 'password' | myLbTranslate }}*</label>
                            <div class="form-content">
                                <app-lb-reveal-password
                                    id="user-password"
                                    class="form-input"
                                    title="{{'password' | myLbTranslate }}"
                                    formControlName="password"
                                    [formGroup]="getFormGroup('step1')">
                                </app-lb-reveal-password>
                                <app-validation-messages [control]="userForm.get('step1.password')">
                                </app-validation-messages>
                            </div>
                        </div>
                        <div class="form-group" [hidden]="moduleIsPortal || getFormGroup('step1.disableUser').disabled">
                            <div class="form-content">
                                <input
                                    class="lb-checkbox"
                                    type="checkbox"
                                    name="disable-user"
                                    id="user-disable"
                                    formControlName="disableUser"/>
                                <label for="user-disable">{{ 'rbac_users_disable_user' | myLbTranslate }}*</label>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="activeStep > 1">
                        <div class="set-content">
                            <span *ngIf="editId">Name: {{ getConcatName() }}</span>
                            <span>Email: {{ getFormGroupName('step1.email').value }}</span>
                            <span *ngIf="!moduleIsPortal">
                                <button class="button-as-link quinary right-arrow" (click)="setStep(1)">
                                    {{ 'edit' | myLbTranslate }}
                                </button>
                            </span>
                            <span *ngIf="editId && moduleIsPortal" class="note">
                                {{ 'rbac_users_update_message' |myLbTranslate }}
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div
                #step
                *ngIf="!isSystemUser"
                class="step"
                [class.active]="activeStep === 2"
                [class.complete]="activeStep > 2"
                formGroupName="step2">
                <h3>{{ 'roles' | myLbTranslate }}</h3>
                <div class="step-content">
                    <ng-container *ngIf="activeStep === 2">
                        <div *ngIf="showRolesGroupsWarning()" class="warning-help-wrapper">
                            <ng-container *ngTemplateOutlet="warning"></ng-container>
                            <app-help class="help-button" tag="rbac-users_roles"></app-help>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="activeStep === 2">
                        <div
                            *ngFor="let role of getFormGroupName('step2.roles').controls index as i"
                            formArrayName="roles"
                            class="form-group">
                            <div class="form-content">
                                <input
                                    class="lb-checkbox"
                                    type="checkbox"
                                    name="role"
                                    id="role{{[i]}}"
                                    [formControl]="role['controls'].value"/>
                                <label for="role{{[i]}}">{{ role.value.name | titlecase }}</label>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="activeStep > 2">
                        <div class="set-content">
                            <span>
                                <strong>{{ 'rbac_group_assign_role_selected' | myLbTranslate }}:</strong>
                            </span>
                            <span>
                                {{ getSelectedItemsAsString(userForm.value['step2'].roles) || ('none_set' | myLbTranslate) }}
                            </span>
                            <span>
                                <button class="button-as-link quinary right-arrow" (click)="setStep(2)">
                                    {{ 'edit' | myLbTranslate }}
                                </button>
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div
                #step
                *ngIf="!isSystemUser"
                class="step"
                [class.active]="activeStep === 3"
                [class.complete]="activeStep > 3"
                formGroupName="step3">
                <h3>{{ 'groups' | myLbTranslate }}</h3>
                <div class="step-content">
                    <ng-container *ngIf="activeStep === 3">
                        <div *ngIf="showRolesGroupsWarning()" class="warning-help-wrapper">
                            <ng-container *ngTemplateOutlet="warning"></ng-container>
                            <app-help class="help-button" tag="rbac-users_groups"></app-help>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="activeStep === 3">
                        <div
                            *ngFor="let group of getFormGroupName('step3.groups').controls index as i"
                            formArrayName="groups"
                            class="form-group">
                            <div class="form-content">
                                <input
                                    class="lb-checkbox"
                                    type="checkbox"
                                    name="group"
                                    id="group{{[i]}}"
                                    [formControl]="group['controls'].value"/>
                                <label for="group{{[i]}}">{{ group.value.name | titlecase }}</label>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="activeStep > 3">
                        <div class="set-content">
                            <span>
                                <strong>{{ 'rbac_groups_selected_groups' | myLbTranslate }}:</strong>
                            </span>
                            <span>
                                {{ getSelectedItemsAsString(userForm.value['step3'].groups) || ('none_set' | myLbTranslate) }}
                            </span>
                            <span>
                                <button class="button-as-link quinary right-arrow" (click)="setStep(3)">
                                    {{ 'edit' | myLbTranslate }}
                                </button>
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
            <ng-container *ngIf="!moduleIsPortal || editId">
                <div
                    #step class="step" [class.active]="activeStep === 4"
                    [class.complete]="activeStep > 4">
                    <h3>{{ 'ready' | myLbTranslate }}</h3>
                    <div class="step-content">
                        <ng-container *ngIf="activeStep === 4">
                            <p>{{ (userForm.pristine ? 'submit_disabled' : 'rbac_group_ready_message') | myLbTranslate }}</p>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </form>
</div>
<div class="component-footer">
    <button id="group-cancel" class="outline" [routerLink]="editId ? '../../../' : '../../'">
        {{ 'cancel' | myLbTranslate }}
    </button>
    <button
        id="group-back"
        [disabled]="activeStep === 1 || (moduleIsPortal && editId && activeStep === 2)"
        class="primary"
        (click)="back()">
        {{ 'back' | myLbTranslate }}
    </button>
    <ng-container *ngIf="activeStep < 4; else userSubmit">
        <button
            id="user-next"
            class="primary"
            [disabled]="isNextButtonDisabled()"
            (click)="next()">
            {{ 'next' | myLbTranslate }}
        </button>
    </ng-container>
    <ng-template #userSubmit>
        <app-loading-button
            buttonId="user-submit"
            buttonClass="primary"
            buttonText="submit"
            [isDisabled]="isSubmitDisabled()"
            [callBack]="submitHelper.bind(this)">
        </app-loading-button>
    </ng-template>
</div>

<ng-template #warning>
    <div class="warning-message">
        <img
            ngSrc="./assets/shared/icons/notification-solid-exclamation-triangle.svg"
            alt="Expiry icon"
            height="20"
            width="20"/>
        <span>{{ 'rbac_users_roles_groups_message' | myLbTranslate }}</span>
    </div>
</ng-template>
